import { useState, type SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/shared/auth/contexte';
import { Button, Champ } from '@/shared/ui';
import { Alerte, CadreConnexion } from './CadreConnexion';

export function MotDePasseOubliePage() {
  const { service } = useAuth();
  const [email, setEmail] = useState('');
  const [erreur, setErreur] = useState<string | undefined>();
  const [refus, setRefus] = useState<string | null>(null);
  const [envoye, setEnvoye] = useState(false);
  const [envoi, setEnvoi] = useState(false);

  async function soumettre(evenement: SyntheticEvent) {
    evenement.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setErreur('Saisissez une adresse e-mail valide.');
      return;
    }
    setEnvoi(true);
    const resultat = await service.demanderReinitialisation(email.trim());
    setEnvoi(false);
    if (resultat.ok) setEnvoye(true);
    else setRefus(resultat.message);
  }

  return (
    <CadreConnexion
      titre="Mot de passe oublié"
      sousTitre="Recevez un lien pour choisir un nouveau mot de passe."
    >
      {envoye ? (
        <Alerte ton="succes">
          Si un compte existe pour {email.trim()}, un lien de réinitialisation vient d’y être
          envoyé.
        </Alerte>
      ) : (
        <form noValidate onSubmit={(e) => void soumettre(e)} className="flex flex-col gap-4">
          <Champ
            libelle="Adresse e-mail"
            type="email"
            autoComplete="email"
            value={email}
            erreur={erreur}
            onChange={(e) => {
              setEmail(e.target.value);
              setErreur(undefined);
            }}
          />
          {refus ? <Alerte ton="danger">{refus}</Alerte> : null}
          <Button type="submit" variante="principal" disabled={envoi} className="h-11">
            Envoyer le lien
          </Button>
        </form>
      )}
      <Link
        to="/connexion"
        className="mt-6 flex items-center justify-center gap-1.5 text-[13px] font-medium text-primary"
      >
        <ArrowLeft className="size-4" aria-hidden />
        Retour à la connexion
      </Link>
    </CadreConnexion>
  );
}
